import React from "react";
import { Card } from "@material-ui/core";

import ManagementTab from "../../containers/WorkTab/ManagementTab";

// [VinUni] Sắp xếp lại 5 loại công trình theo PDF; các loại khác tạm ẩn (giữ code)
const tabList = [
  { key: "scientificResearch", title: "Bài báo khoa học" },
  { key: "monograph", title: "Sách/Biên soạn giáo trình" },
  { key: "project", title: "Đề tài" },
  { key: "solution", title: "Giải pháp hữu ích" },
  { key: "patent", title: "Bằng sáng chế" },
  // [VinUni] Tạm ẩn các công trình khác (giữ code, mở lại khi cần)
  // { key: "presentation", title: "Bài trình bày, truyền thông, phỏng vấn, truyền hình" },
  // { key: "researchProposal", title: "Đề xuất nghiên cứu" },
  // { key: "programDirector", title: "Ban chủ nghiệm các chương trình Cấp Quốc gia" },
  // { key: "otherWork", title: "Các hoạt động khác" },
  // { key: "studentGuidance", title: "Hướng dẫn NCKHSV/Đạt giải NCKH và tương đương" },
];

const height = "calc(100vh - 92px)";

function Management() {
  return (
    <Card
      style={{
        height: height,
        minHeight: height,
        maxHeight: height,
        position: "relative",
      }}
    >
      <ManagementTab tabList={tabList} />
    </Card>
  );
}

export default Management;

